import React from 'react'
import App from './App'
import New from './New'


function Main() {
  return (
    <>
    <App/>
    {/* <New/> */}
    </>
  )
}


export default Main